
import React, { useRef } from 'react';

interface DesktopCostViewProps {
  particlesRef: React.RefObject<HTMLDivElement>;
}

const DesktopCostView: React.FC<DesktopCostViewProps> = ({ particlesRef }) => {
  return (
    <div className="container">
      <p className="subtitle">Munger eliminates the costs of email infrastructure, contact lists, domains, experts/agencies, email marketing tools, time, error handling, email warm up, email support tools, appointment scheduling software, AI personalization tools, email copywriting AI, and sales reps.</p>
      
      <div className="visualization">
        <div className="cost-column">
          <div className="column-title">Traditional Email Costs</div>
          <div className="costs-container">
            <div className="cost-bar" id="traditional-bar"></div>
            <div className="cost-item" style={{top: '0px'}}>
              <div className="cost-name">Email Infrastructure</div>
              <div className="cost-value">$12,000/yr</div>
            </div>
            <div className="cost-item" style={{top: '40px'}}>
              <div className="cost-name">Contact Lists</div>
              <div className="cost-value">$9,600/yr</div>
            </div>
            <div className="cost-item" style={{top: '80px'}}>
              <div className="cost-name">Domain Management</div>
              <div className="cost-value">$2,400/yr</div>
            </div>
            <div className="cost-item" style={{top: '120px'}}>
              <div className="cost-name">Email Marketing Tools</div>
              <div className="cost-value">$7,200/yr</div>
            </div>
            <div className="cost-item" style={{top: '160px'}}>
              <div className="cost-name">Expert/Agency Fees</div>
              <div className="cost-value">$24,000/yr</div>
            </div>
            <div className="cost-item" style={{top: '200px'}}>
              <div className="cost-name">Sales Rep Time</div>
              <div className="cost-value">$18,000/yr</div>
            </div>
            <div className="cost-item" style={{top: '240px'}}>
              <div className="cost-name">AI Tools</div>
              <div className="cost-value">$2,800/yr</div>
            </div>
          </div>
        </div>
        
        <div className="vs-section">
          <div className="savings-arrow">
            <div className="arrow-body"></div>
            <div className="arrow-head"></div>
            <div className="savings-percentage">90%+ Savings</div>
          </div>
          <div className="vs-circle">VS</div>
        </div>
        
        <div className="cost-column">
          <div className="column-title">Munger All-In-One</div>
          <div className="munger-cost">
            <div className="munger-bar" id="munger-bar"></div>
            <div className="munger-icon">
              <div className="munger-pulse"></div>
              <div className="munger-icon-inner">
                <div className="munger-icon-core">M</div>
              </div>
            </div>
            <div className="munger-cost-value">$20</div>
            <div className="munger-cost-label">per 20,000 emails</div>
          </div>
        </div>
      </div>
      
      <div className="savings-banner">Your Potential Savings: $74,800/year</div>
      
      <div className="particles-container" id="particles" ref={particlesRef}></div>
    </div>
  );
};

export default DesktopCostView;
